// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_57-2";
export var blackBorderOnHover = "_57-7";
export var cell = "_57-6";
export var cellContainer = "_57-3";
export var checked = "_57-8";
export var disabled = "_57-5";
export var featuredIconCellContainer = "_57-9";
export var featuredIconTextContainer = "_57-b";
export var featuredIconWrapper = "_57-a";
export var noBorder = "_57-c";
export var orangeSelectedRow = "_co-3";
export var overflowableText = "_57-0";
export var overflowableTextContainer = "_57-1";
export var row = "_5a-0";
export var rowCheckboxCell = "_57-4";
export var selectableTable = "_co-2";